import { APIValidationError } from '../../types/api/api';
import toQueryParams from '../../utils/toQueryParams';
import { Result, validatedApiCall } from '../api';
import { ConsultesFilters } from './getConsultes';

export interface ConsultaExport {
  content: string;
}

export type GetExportConsultaDTO = ConsultesFilters;

export const getExportConsulta = async (
  data: GetExportConsultaDTO,
): Promise<Result<ConsultaExport, APIValidationError>> => {
  return validatedApiCall<ConsultaExport>(
    `/api/consultes/exports/csv?${toQueryParams(
      data as unknown as Record<string, string>,
    )}`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
